import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledFormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};

  & input {
    background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  }
`;
